__turbopack_context__.v({
  "root": "_0wJt7G_root",
});
